import Button from "../Button/Button";
import TableCell from "./TableCell";
import styles from "./table.module.css";
import cn from 'classnames';

export default function TableFooter({ children, className }) {
  return (
    <div className={cn(styles.tfoot, className && className)}>
      {children}
      {/* <Button text="Предыдущая"></Button>
          <span className={styles.paginationTitle}>Страница 1 из 10</span>
          <Button text="Следующая"></Button> */}
    </div>
  )
}